'use strict';
import { cn_add, cn_element_type_input, cn_image_dir, cn_image_input, cn_middle, cn_molding_type, cn_mul, cn_pastille, cn_scene, cn_space, cn_wall } from '..';
//***********************************************************************************
//***********************************************************************************
//**** cn_svg_tool_molding  : molding Manager
//***********************************************************************************
//***********************************************************************************
import { cn_camera } from './cn_camera';
import { cn_svg_map } from './cn_svg_map';
import { cn_svg_tool_creation } from './cn_svg_tool_creation';
import { cn_edition_handler } from './cn_edition_handler';
import { cn_element } from '../model/cn_element';
import { cn_facing_family } from '../model/cn_facing_family';
import { CN_FACING_SUPPORTS } from '../model/cn_model_constants';
import { cn_bbp_geometry } from '../utils/cn_bbp_geometry';
import { HELPER } from '../utils/cn_wordings';

/**
 */
export class cn_svg_tool_molding extends cn_svg_tool_creation {
    //***********************************************************************************
    /**
     * Constructor
     * @param {cn_svg_map} svg_map
     */
    constructor(svg_map) {
        super(svg_map);
        this.selected_element = null;
        this.mouseover_element = null;
        this.mouseover_storey = null;
        this.mouseover_side = null;
        this.mouseover_molding = null;
        this.mouseover_object = null;
        this.mouseover_siblings = [];
        this.selected_siblings = [];
        this.molding_pastilles = [];
        this._molding_lineic_molding = null;
        this._molding_lineics = [];
        this._molding_lineics_date = 0;
    }


    //***********************************************************************************
    /**
     * Open tool
     */
    open_tool() {
        super.open_tool();
        this.push_instruction_input(HELPER.molding.creation);
    }

    //***********************************************************************************
    /**
     * Close tool
     */
    close_tool() {
        super.close_tool();
    }

    highlight_molding(cn_molding_type) {
        this.refresh();
    }

    //***********************************************************************************
    /**
     * SVG rendering
     * @param {cn_camera} camera
     * @returns {string} svg rendered
     */
    // @ts-ignore
    draw(camera) {
        let html = '';

        if (this.selected_element) {
            html += this.selected_element.draw(camera, ['selected', 'no_children']);
            this.molding_pastilles.forEach(pastille => {
                if (pastille["molding"])
                    pastille.label = pastille["molding"].draw_svg_icon(pastille.rectangle[0], pastille.rectangle[1]);
                html += pastille.draw(camera);
            });
        }

        if (this.mouseover_element && (!this.selected_element || this.mouseover_element.ID !== this.selected_element.ID)) {
            html += this.mouseover_element.draw(camera, ['mouseover', 'no_children']);
        }

        html += super.draw(camera);
        return html;
    }

    _select_element(element) {
        if (this.selected_element == element) return;
        this.selected_element = element;

        this.refresh_pastilles();
    }

    refresh_pastilles() {
        this.molding_pastilles = [];
        if (this.selected_element) {
            if (this.selected_element.constructor === cn_wall && this.selected_element.has_facings()) {
                this.selected_element.space_segments.forEach(sp => this._select_space_segment(sp));
            } else if (this.selected_element.constructor === cn_space) {
                this.selected_element.space_segments.forEach(sps => {
                    sps.filter(sp => sp.wall && sp.wall.has_facings()).forEach(sp => this._select_space_segment(sp));
                });
            }
        }
    }

    _select_space_segment(space_segment) {
        let p0 = cn_middle(space_segment.points[0], space_segment.points[1]);
        let offset = cn_mul([-space_segment.normal[0], space_segment.normal[1]], 30);
        let dx = 0;
        if (offset[0] > 0) dx = 60;
        else if (offset[0] < 0) dx = -60;
        else if (offset[1] > 0) dx = 60;
        else dx = -60;

        for (var i = 0; i <= space_segment.moldings.length; i++) {
            this._create_pastilles(space_segment, i, p0, offset);
            offset = cn_add(offset, [dx, 0]);
        }
    }

    _create_pastilles(space_segment, index, p0, offset) {
        let molding = (index < space_segment.moldings.length) ? space_segment.moldings[index] : null;

        let scene = space_segment.space.scene;
        let all_space_segments = space_segment.space.space_segments.flatMap(ssl => ssl);
        let similar_spaces = [];
        let space_category = 0;
        if (space_segment.space.outside)
            similar_spaces = [space_segment.space];
        else {
            let heated_relevant = space_segment.space.is_heated_relevant(scene.storey);
            space_category = (heated_relevant) ? 2 : 1;
            similar_spaces = scene.spaces.filter(space => !space.outside && space.is_heated_relevant(scene.storey) == heated_relevant);
        }
        let all_storey_segments = [];
        similar_spaces.forEach(sp => all_storey_segments = all_storey_segments.concat(sp.space_segments.flatMap(ssl => ssl)))
        const type_pastille = new cn_pastille(p0);
        type_pastille.offset = offset;
        type_pastille.rectangle = [40, 40];
        if (molding) {
            type_pastille.label = molding.draw_svg_icon(type_pastille.rectangle[0], type_pastille.rectangle[1]);
            type_pastille.title = "Modifier ou supprimer une moulure";
            type_pastille["molding"] = molding;
        }
        else {
            type_pastille.label = "tool_add.png";
            type_pastille.svg_class = 'pastille_background white';
            type_pastille.title = "Ajouter une moulure";
        }
        type_pastille.clicked = () => {
            const input = new cn_element_type_input('Choix du type de moulure');
            let null_type = new cn_molding_type(null);
            null_type.is_null = true;
            input.choices = [null_type, ...this._building.get_molding_types()];
            let index = input.choices.indexOf(molding);
            if (index < 0) index = 0;
            input.selection = [index];
            input.options_labels = ["Uniquement cette paroi"];
            if (space_category == 0) {
                input.options_labels.push("Appliquer à toutes les façades");
            }
            else if (space_category == 2) {
                input.options_labels.push("Appliquer à tous les murs de la pièce");
                input.options_labels.push("Appliquer à toutes les pièces du niveau");
            }
            else {
                input.options_labels.push("Appliquer à tous les murs de l'espace");
                input.options_labels.push("Appliquer à tous les espaces extérieurs du niveau");
            }
            let options_selected_index = (all_space_segments.some(ss => !ss.moldings.includes(molding))) ? 0 : (all_storey_segments.some(ss => !ss.moldings.includes(molding))) ? 1 : 2;
            if (space_category == 0 && options_selected_index == 2) options_selected_index = 1;
            input.options_selected = input.options_labels[options_selected_index];
            input.callback = () => {
                this.push_transaction('Modification des moulures');
                options_selected_index = input.options_labels.indexOf(input.options_selected);
                let space_segments = (options_selected_index == 2) ? all_storey_segments : (options_selected_index == 1) ? all_space_segments : [space_segment];
                let new_molding = (input.selection[0] > 0) ? input.choices[input.selection[0]] : null;
                space_segments.forEach(ss => {
                    this.push_item_set(ss, ['moldings', 'molding_facings']);
                    let index = ss.moldings.indexOf(molding);
                    if (!new_molding) {
                        if (molding && index >= 0) {
                            ss.moldings.splice(index, 1);
                            ss.molding_facings.splice(index, 1);
                        }
                    }
                    else if (index >= 0) {
                        ss.moldings[index] = new_molding;
                    }
                    else {
                        ss.moldings.push(new_molding);
                        ss.molding_facings.push(null);
                    }
                });
                this.refresh_pastilles();
                this._map.refresh_tool();
            };
            this._map.call('element_type_input', input);
        };
        this.molding_pastilles.push(type_pastille);

        if (!molding) return;

        let molding_facing = space_segment.molding_facings[index];
        const facing_pastille = new cn_pastille(p0);
        facing_pastille.rectangle = [20, 20];
        facing_pastille.offset = cn_add(offset, [0, 40]);
        facing_pastille.title = "Revêtement de moulure";
        facing_pastille.draw = (camera) => {
            let html = ''
            let texture = (molding_facing) ? molding_facing.texture : "";
            let color = '#FFFFFF';
            if (molding_facing && molding_facing.color) color = molding_facing.color;
            html = facing_pastille.draw_texture(camera, texture, color);
            return html;
        };
        facing_pastille.clicked = () => {
            const input = new cn_image_input('Veuillez choisir un revêtement de moulure');
            const facing_family = cn_facing_family.get_facing_group(CN_FACING_SUPPORTS.MOLDING, this._map._building);
            const facings = facing_family.facings;
            facings.unshift(null);
            input.choices = facings.map(f => {
                return { label: f ? f.name : 'Aucun', url: `${cn_image_dir()}texture_${f ? f.texture : ''}.jpg`, maskColor: f ? f.color : 'transparent' };
            });
            input.options_labels = ["Uniquement à cette moulure", "Appliquer à toutes les moulures identiques de la pièce", "Appliquer à toutes les moulures identiques de ce niveau"];
            input.options_selected = input.options_labels[0];
            input.selection = [facings.findIndex(f => (molding_facing && f && molding_facing.ID === f.ID) || (!molding_facing && !f))];
            input.callback = () => {
                this.push_transaction('Modification des revêtements de moulures');
                let new_facing = facings[input.selection[0]];
                let space_segments = [space_segment];
                if (input.options_selected == input.options_labels[1]) space_segments = all_space_segments;
                else if (input.options_selected == input.options_labels[2]) space_segments = all_storey_segments;
                space_segments.forEach(ss => {
                    let index = ss.moldings.indexOf(molding);
                    if (index >= 0) {
                        this.push_item_set(ss, 'molding_facings');
                        ss.molding_facings[index] = new_facing;
                    }
                });
                this.refresh_pastilles();
                this._map.refresh_tool();
            }
            this._map.call('image_input', input);
        }

        this.molding_pastilles.push(facing_pastille);
    }

    //***********************************************************************************
    /**
     * click
     * @returns {boolean}
     */
    click(ev) {
        if (this.mouseover_molding) {
            this.mouseover_molding.clicked();
            return true;
        }
        this._select_element(this._find_molding_element(ev));
        return true;
    }

    /**
     * move
     *
     * @param {object} ev
     * @returns {boolean}
     */
    move(ev) {
        this.mouseover_molding = null;
        this.mouseover_element = null;
        this.mouseover_siblings = [];
        this.clear_move();

        this.molding_pastilles.forEach(pastille => {
            pastille.mouseover = pastille.contains(ev.mouse_world, ev.camera);
            if (pastille.mouseover) this.mouseover_molding = pastille;
        });

        if (this.mouseover_molding)
            return true;

        this.mouseover_element = this._find_molding_element(ev);
        if (this.mouseover_element)
            return true;

        return false
    }

    /** See what molding bearing element is present under the mouse. */
    _find_molding_element(ev) {
        let elt = this._scene.find_wall(ev.mouse_world, ev.camera.snap_world_distance);
        if (elt || this._scene.constructor != cn_scene) return elt;
        return this._scene.find_space(ev.mouse_world, ev.camera.snap_world_distance);
    }
}

